<template>
  <b-container fluid class="p-0 h-100" id="media-feed" style="overflow-y: auto;">
    <b-row no-gutters class="p-2 pt-2 shadow-sm" :class="!isMobile ? 'sticky-top' : ''" style="background-color: #ffffff;">
      <b-col>
        <h3 class="mb-1 ml-1">Feed <div class="badge badge-primary badge-pill">{{ itemsList.length }}</div></h3>
      </b-col>
      <b-col>
        <b-dropdown v-if="tagList.length > 0"
                    :text="(selectedTag !== null && selectedTag !== 'all') ? dropdownLabel(selectedTag) : 'Filter by tag..'"
                    :variant="categoryVariant(selectedTag)" class="float-right">
          <b-dropdown-item @click="chooseTag(null)">All</b-dropdown-item>
          <b-dropdown-item v-for="tag in tagList" :key="tag" @click="chooseTag(tag)">
            {{ tag }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col>
        <div style="display: table;" v-for="item in itemsList" :key="item.index" class="feed-item" :id="'feed-item-' + item.index">
          <div style="display: table-cell; width: 10px;"></div>
          <div style="display: table-cell; width: 5px; vertical-align: top;" :style="{ 'background-color': feedLineColor }">
            <small><font-awesome-icon :icon="['fas', 'circle']" class="feed-item-icon" :style="{ color: feedLineColor, 'margin-top': '30px', 'margin-left': '-1px' }" /></small>
          </div>
          <div style="display: table-cell; width: 10px;"></div>
          <div style="display: table-cell;">
            <b-button variant="white" class="feed-item-button text-left mt-2 mr-2 p-3 border shadow-sm"
                      :style="{ 'border': feedItemBorder(item) }"
                      @click="selectFeedItem(item.index)"  :id="'item' + item.index">
              <div class="mb-1">
              <span v-b-tooltip="'Show on map'" class="text-muted">
                <small><font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2" /><span>{{ position(item) }}</span></small>
              </span>
              <a class="float-right" v-if="item.link" :href="item.link" target="_blank">
                <small><strong>Open</strong><font-awesome-icon :icon="['fas', 'external-link-alt']" class="ml-1" /></small>
              </a>
              </div>
              <h6 v-if="item.title && !item.categories.includes('Social Media')"><strong>{{ item.title }}</strong></h6>
              <div v-if="item.media" class="mb-2">
                <b-img v-if="item.media.type === 'image/jpeg'" crossorigin="anonymous" :src="'https://beluga.geomar.de/proxy.php?url=' + encodeURIComponent(item.media.url)" style="width: 100%;" fluid rounded></b-img>
                <b-embed v-else-if="item.media.type === 'youtube'"
                  type="iframe"
                  aspect="16by9"
                  :src="item.media.url"
                  allowfullscreen
                ></b-embed>
                <audio controls class="feed-audio-bar" v-else-if="item.media.type === 'audio/mpeg'" :src="item.media.url" :type="item.media.type">Audio not possible</audio>
              </div>
              <div v-if="item.description" style="line-height: 1.0rem;" class="mb-2">
                <small>
                  {{ description(item) }}
                  <!--<span v-if="item.link && description(item).length > 150">
                    <a :href="item.link" class="mt-2" target="_blank">
                    <strong>Read more</strong><font-awesome-icon :icon="['fas', 'external-link-alt']" class="fa-xs mt-2 ml-1" />
                  </a>
                  </span>-->
                </small>
              </div>
              <div v-if="item.author" style="line-height: 1.0rem;" class="mb-2 text-muted">
                <small><i>{{ author(item) }}</i></small>
              </div>
              <div>
                <div>
              <span v-if="item.pub_date" class="text-muted">
                <font-awesome-icon :icon="['far', 'calendar-alt']" class="mr-2" /><small>{{ parseItemDate(item.pub_date) }}</small>
              </span>
                  <span v-if="item.categories.length <= 2" class="float-right">
                <b-badge :variant="categoryVariant(cat)" @click="chooseTag(cat)" v-for="cat in item.categories" :key="cat" class="mr-1">{{ cat }}</b-badge>
              </span>
                </div>
                <div v-if="item.categories.length > 2" class="mt-1 float-left">
                  <b-badge :variant="categoryVariant(cat)" v-for="cat in item.categories" :key="cat" class="mr-1">{{ cat }}</b-badge>
                </div>
              </div>
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import Helpers from '@/mixins/helpers'
import $ from 'jquery'

const DESCRIPTION_MAX_LENGTH = 250
const TAG_MAX_LENGTH = 20

const INVALID_COORDINATES = { lat: 0, lng: 0 }
const MEDIUM_BREAKPOINT = 1024

export default {
  name: 'MediaFeed',
  mixins: [
    Helpers
  ],
  data () {
    return {
      DESCRIPTION_MAX_LENGTH: DESCRIPTION_MAX_LENGTH,
      selectedTag: null,
      itemsList: null
    }
  },
  created () {
    // Init media feed items
    this.itemsList = this.mediaFeed.channel.items
    // Subscribe to store mutations
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'select_campaign') {
        this.updateFeed()
      } else if (mutation.type === 'select_feed_item') {
        if (mutation.payload !== null) {
          $('#media-feed').stop().animate({
            scrollTop: $('#feed-item-' + mutation.payload).position().top
          }, 900, 'swing')
        }
      }
    })
  },
  beforeDestroy () {
    // Unsubscribe from mutations
    this.unsubscribe()
  },
  methods: {
    ...mapMutations(['select_feed_item']),
    selectFeedItem: function (index) {
      // Select feed item and open popup
      this.select_feed_item(index)
      if (!this.isMobile) {
        this.campaignSelected.map.feed_items[index].openPopup()
      }
    },
    parseItemDate: function (date) {
      // const formats = ['YYYY-MM-DD', 'MMMM Do YYYY, h:mm:ss']
      return moment(date).format('MMMM DD YYYY')
    },
    updateFeed: function () {
      if (this.mediaFeed !== null) {
        this.itemsList = this.mediaFeed.channel.items
      }
    },
    chooseTag: function (tag) {
      // Update list of items matching the category
      this.selectedTag = tag
      if (tag === null) {
        if (this.mediaFeed.channel.items.length > 0) {
          this.itemsList = this.mediaFeed.channel.items
        } else {
          this.itemsList = []
        }
      } else {
        const res = []
        if (this.mediaFeed.channel.items) {
          let i
          for (i = 0; i < this.mediaFeed.channel.items.length; i++) {
            if (this.mediaFeed.channel.items[i].categories) {
              if (this.mediaFeed.channel.items[i].categories.includes(tag)) {
                res.push(this.mediaFeed.channel.items[i])
              }
            }
          }
        }
        this.itemsList = res
      }
    }
  },
  computed: {
    ...mapState(['selectedCampaign', 'selectedFeedItem']),
    ...mapGetters(['mediaFeed', 'campaignSelected', 'platforms', 'mediaFeed']),
    isMobile: function () {
      return this.$root.window.width <= MEDIUM_BREAKPOINT
    },
    feedLineColor: function () {
      if (this.selectedCampaign !== null &&
        this.campaignSelected.project_platform > 0 &&
        Number(this.campaignSelected.project_platform) in this.platforms) {
        return this.platforms[this.campaignSelected.project_platform].color
      }
      return '#007bff'
    },
    feedItemBorder: function () {
      return (item) => {
        if (item.index === this.selectedFeedItem) {
          if (this.selectedCampaign !== null &&
            this.campaignSelected.project_platform > 0 &&
            Number(this.campaignSelected.project_platform) in this.platforms) {
            return '2px solid ' + this.platforms[this.campaignSelected.project_platform].color + ' !important'
          }
          return '2px solid #007bff !important'
        }
        return '2px solid rgb(222, 226, 230) !important'
      }
    },
    categoryVariant: function () {
      return (category) => {
        if (category !== null) {
          category = category.toLowerCase()
          if (category === 'wissenschaft') {
            return 'info'
          } else if (category === 'news' || category === 'ocean blog' || category === 'blog') {
            return 'primary'
          } else if (category === 'podcast') {
            return 'success'
          } else if (category === 'werft') {
            return 'warning'
          } else if (category === 'logbuch') {
            return 'info'
          } else if (category === 'social media') {
            return 'danger'
          }
          return 'light'
        }
        return 'light'
      }
    },
    position: function () {
      return (item) => {
        if ('position' in item) {
          if (!this.compareCoordinates(item.position, INVALID_COORDINATES)) {
            const position = this.getCoordinatesNautical(this.roundDigits(item.position.lat, 5),
              this.roundDigits(item.position.lng, 5))
            return position.lat + ' ' + position.lng
          }
        }
        return 'No location'
      }
    },
    description: function () {
      return (item) => {
        let abstract = item.description.replace(/(<([^>]+)>)/gi, '')
        if (abstract.length > DESCRIPTION_MAX_LENGTH) {
          abstract = abstract.substr(0, DESCRIPTION_MAX_LENGTH) + '...'
        }
        return abstract
      }
    },
    author: function () {
      return (item) => {
        const cursor = item.author.indexOf('(') + 1
        if (cursor > 0) {
          return item.author.substring(cursor).replace(')', '')
        }
        return item.author
      }
    },
    dropdownLabel: function () {
      return (tag) => {
        if (tag.length > TAG_MAX_LENGTH) {
          return tag.substr(0, TAG_MAX_LENGTH) + '..'
        }
        return tag
      }
    },
    tagList: function () {
      const res = []
      if ('items' in this.mediaFeed.channel) {
        this.mediaFeed.channel.items.forEach(item => {
          if ('categories' in item) {
            for (const category of item.categories) {
              if (!(res.includes(category))) {
                res.push(category)
              }
            }
          }
        })
      }
      return res
    }
  }
}

</script>

<style lang="scss">
.feed-item:last-child {
  .feed-item-button {
    margin-bottom: 10px;
  }
}

</style>

<style scoped>

html {
  scroll-behavior: smooth;
}

.container {
  overflow-y: auto;
  height: inherit;
}

.btn-white:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.feed-item-icon {
  left: 6px;
  margin-top: 31px;
  position: absolute;
  background: #ffffff;
  padding:1px;
}

.feed-audio-bar {
  width: 100%;
}

</style>
